function maskEnd (str, keepLength, replaceSymbol) {
  let firstXChars = ''
  if (str) {
    firstXChars = str.slice(0, keepLength)
    return firstXChars.padEnd(str.length, replaceSymbol)
  }
  return ''
}

function maskMiddle (str, replaceSymbol = '*') {
  if (str && str.length > 2) {
    return str.slice(0, 1) + ''.padEnd(str.length - 2, replaceSymbol) + str.slice(-1)
  }
  return str
}

function isFieldBlank (v) {
  return !v || (v.length && v.length < 1)
}

function nvl (str, rpl) {
  if (str) { return str } else { return rpl }
}

// trim the extension and return the filename part
function filename (fname) {
  return fname.split('.').slice(0, -1).join('.')
}

// get the file extension
function fileExt (fname) {
  return fname.slice((fname.lastIndexOf('.') - 1 >>> 0) + 2)
}

export default { maskEnd, isFieldBlank, maskMiddle, nvl, filename, fileExt }
export { maskEnd, isFieldBlank, maskMiddle, nvl, filename, fileExt }
